<ng-template #exitIntentModal>
  <div class="overlay">
    <div class="overlay__header" *ngIf="showClose">
      <div class="supporter_wrap" *ngIf="vwo.exit_intent_AB()==='exit_intent_trust'">
        <img src="assets/images/supporter_img.png" alt="supporter" class="support_img" />
        <div class="supporter_text">
          <div class="supporter_text_title">{{supporterCount}}+ </div>
          <div class="supporter_text_subtitle">supporters </div>
        </div>
      </div>
      <button type="button" class="overlay__close" (click)="handleClose()"aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="overlay__body">
      <div class="exit-intent">
        <div class="illustration" aria-hidden="true">
          <img class="art" src="assets/images/back_modal_img.png" alt="Helping hands illustration" />
        </div>
        <div class="copy">
          <h3 class="title">{{subtitle}}</h3>
          <p class="desc" [innerHTML]="desc"></p>
        </div>
        <div class="actions">
          <div class="action-top">
            <app-basic-button [label]="btnlabel"
              [themeConfig]="{width: '100%', height: '52px', borderRadius: '32px',bgColor: '#01BFBD', textColor: '#FCFCFC', fontSize: '16px', fontWeight: '700'}"
              (btnClicked)="HandleHelp()">
            </app-basic-button>

            <div class="secure"  *ngIf="vwo.exit_intent_AB()==='exit_intent_trust'">
              <img src="assets/icons/lock.png" class="secure-icon" alt="secure" />
              <span class="secure-text">Secure, Verified, Transparent Giving</span>
            </div>
          </div>
          <app-basic-button [label]="'Maybe later'"
            [themeConfig]="{width: '100%', height: '52px', borderRadius: '32px',borderColor: '#F3F3F3',bgColor: '#F3F3F3', textColor: '#737373', fontSize: '16px', fontWeight: '700'}"
            (btnClicked)="maybeLater()"></app-basic-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>